import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { AiActivitiesPageComponent } from './ai-activities-page.component';
import { AiActivitiesModule } from 'src/app/shared/ai-assistant/ai-activities/ai-activities.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.aiActivities',
    url: '/aiActivities',
    component: AiActivitiesPageComponent,
    data: {
      requireLogin: true
    }
  }
];

@NgModule({
  declarations: [AiActivitiesPageComponent],
  imports: [
    CommonModule,
    AiActivitiesModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [AiActivitiesPageComponent],
  entryComponents: [AiActivitiesPageComponent]
})
export class AiActivitiesPageModule { }
